import { render, staticRenderFns } from "./CourierList.vue?vue&type=template&id=2b5be270"
import script from "./CourierList.vue?vue&type=script&lang=js"
export * from "./CourierList.vue?vue&type=script&lang=js"
import style0 from "./CourierList.vue?vue&type=style&index=0&id=2b5be270&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports